module.exports = __webpack_public_path__ + "img/ServiceManager.276b3e2b.svg";